export const FIRM = {
  name: 'Cullen Macleod Lawyers',
  shortName: 'Cullen Macleod',
  phoneDisplay: '08 9389 3999',
  phoneHref: 'tel:+61893893999',
  email: 'mail@cullenmacleod.com.au',
  emailHref: 'mailto:mail@cullenmacleod.com.au',
  addressLine1: 'Level 2/95 Stirling Hwy',
  addressLine2: 'Nedlands WA 6009',
  logo: 'https://cdn.magicpatterns.com/uploads/q8VzKirzSKPonWVL6Y5CK8/cullenmacleod-logo.svg',
  positioning:
    'Practical, strategic WA lawyers for business, property, disputes, succession and family matters — clear advice, commercial thinking, and a defined path forward.',
}

export type MegaColumn = {
  title: string
  href: string
  links: { label: string; href: string }[]
}

export type NavItem = {
  label: string
  href: string
  columns?: MegaColumn[]
  intro?: { heading: string; body: string; cta: string }
}

export const NAV: NavItem[] = [
  {
    label: 'For You',
    href: '/services',
    intro: {
      heading: 'Personal & family legal matters',
      body: 'Clear, calm guidance through separation, parenting, property settlement, wills and estate planning.',
      cta: 'Speak with a family lawyer',
    },
    columns: [
      {
        title: 'Family Law',
        href: '/services/family-law',
        links: [
          { label: 'Divorce', href: '/services/family-law' },
          { label: 'Property Settlements', href: '/services/family-law' },
          { label: 'Parenting Arrangements', href: '/services/family-law' },
          { label: 'Child Support', href: '/services/family-law' },
          {
            label: 'Binding Financial Agreements',
            href: '/services/family-law',
          },
        ],
      },
      {
        title: 'Wills & Estates',
        href: '/services/wills-estates',
        links: [
          { label: 'Wills & Estate Planning', href: '/services/wills-estates' },
          {
            label: 'Probate & Estate Administration',
            href: '/services/wills-estates',
          },
          {
            label: 'Enduring Powers of Attorney',
            href: '/services/wills-estates',
          },
          { label: 'Testamentary Trusts', href: '/services/wills-estates' },
        ],
      },
    ],
  },
  {
    label: 'For Business',
    href: '/services',
    intro: {
      heading: 'Commercial legal thinking',
      body: 'Practical advice for contracts, structures, disputes, staff and the sale or succession of your business.',
      cta: 'Speak with a commercial lawyer',
    },
    columns: [
      {
        title: 'Commercial & Business Law',
        href: '/services/commercial-business-law',
        links: [
          {
            label: 'Business Structures',
            href: '/services/commercial-business-law',
          },
          { label: 'Contracts', href: '/services/commercial-business-law' },
          {
            label: 'Shareholder, Partnership & JV Agreements',
            href: '/services/commercial-business-law',
          },
          {
            label: 'Business Sale & Purchase',
            href: '/services/commercial-business-law',
          },
          {
            label: 'Business Succession',
            href: '/services/commercial-business-law',
          },
        ],
      },
      {
        title: 'Disputes & More',
        href: '/services/dispute-resolution',
        links: [
          {
            label: 'Dispute Resolution & Litigation',
            href: '/services/dispute-resolution',
          },
          {
            label: 'Employment & Workplace Relations',
            href: '/services/employment',
          },
          { label: 'Franchising Law', href: '/services/franchising' },
        ],
      },
    ],
  },
  {
    label: 'Property & Conveyancing',
    href: '/services/property-law',
    intro: {
      heading: 'Property matters, handled properly',
      body: 'Settlement support and legal advice for buyers, sellers, investors and developers across WA.',
      cta: 'Speak with a property lawyer',
    },
    columns: [
      {
        title: 'Property Law',
        href: '/services/property-law',
        links: [
          { label: 'Buying Property', href: '/services/property-law' },
          { label: 'Selling Property', href: '/services/property-law' },
          { label: 'Commercial Property', href: '/services/property-law' },
          { label: 'Property Disputes', href: '/services/property-law' },
        ],
      },
      {
        title: 'Conveyancing & Settlements',
        href: '/services/conveyancing',
        links: [
          {
            label: 'Conveyancing & Settlements',
            href: '/services/conveyancing',
          },
          { label: 'Commercial Leasing', href: '/services/conveyancing' },
          {
            label: 'Development & Due Diligence',
            href: '/services/conveyancing',
          },
        ],
      },
    ],
  },
  {
    label: 'Wills & Estates',
    href: '/services/wills-estates',
  },
  {
    label: 'Resources',
    href: '/#guides',
    intro: {
      heading: 'Guidance before you decide',
      body: 'Plain-English guides, checklists and answers to help you make a confident next move.',
      cta: 'Browse legal guides',
    },
    columns: [
      {
        title: 'Guides & Answers',
        href: '/#guides',
        links: [
          { label: 'Legal Guides', href: '/#guides' },
          { label: 'FAQs', href: '/#faq' },
          { label: 'Articles', href: '/#guides' },
          { label: 'Forms', href: '/#guides' },
        ],
      },
      {
        title: 'Working With Us',
        href: '/#process',
        links: [
          { label: 'What to Expect', href: '/#process' },
          { label: 'Fees & How We Charge', href: '/#faq' },
        ],
      },
    ],
  },
  { label: 'About', href: '/#trust' },
  { label: 'Contact', href: '/enquiry' },
]

export const HELP_OPTIONS = [
  'Business & Commercial',
  'Disputes & Litigation',
  'Property & Conveyancing',
  'Family Law',
  'Wills, Estates & Succession',
  'Franchising',
  'Employment & Workplace',
  'Not sure yet',
]
